/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useFilters from '../useFilters'
import { Checkbox, FormField } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { UltyInputText } from '@ulty/ulty-ui'

const IsScheduledFilter = () => {
    const [t] = useTranslation()
    const {filters, setFilters} = useFilters()

    const handleIsScheduledChange = (newIsScheduled) => {
        const newFilters = {
            ...filters,
            isScheduled: newIsScheduled,
        }

        setFilters(newFilters)
    }

    return (
      <FormField css={css`
          display: flex;
          flex-direction: column;
          row-gap: .5rem;
      `}>
          <UltyInputText
            readonly
            label={t('order.scheduled.isScheduledOrder')}
          />
          <Checkbox
            css={css`
                &.ui.toggle.checkbox > label {
                    font-weight: 700;
                    font-size: .92857143em;
                }
            `}
            checked={filters.isScheduled}
            toggle
            onChange={(evt, {checked}) => handleIsScheduledChange(checked)}
          />
      </FormField>
    )
}

export { IsScheduledFilter }
